@import "/src/styles/mixins.sass"

.container
    flex-grow: 1
    display: flex
    align-items: center
    justify-content: center

.error
    @include label-large($disabled: true)

.simulation
    display: flex
    flex-direction: column
    gap: 1.5rem
    width: 38rem

    section
        display: grid
        grid-template-columns: 2fr 1fr

    section > span
        @include text

    .metadata
        margin-top: 2rem
        gap: 1.25rem 1rem

    .warning, .status, .actions
        margin-top: 1rem

    .warning
        @include text-small
        display: flex
        align-items: center
        gap: 1rem

    .status, .parameters
        border-left: var(--color-grey-primary) 0.2rem solid

        span
            padding: 0.75rem

            span.skelet
                padding: 0

        span:nth-child(odd)
            @include text--regular

    .status
        span:not(.skelet):nth-child(4n + 3), span:not(.skelet):nth-child(4n + 4)
            background-color: var(--color-grey-light)

        span:nth-child(4n + 4)
            border-radius: 0 0.75rem 0.75rem 0

    .parameters
        span:not(.skelet):nth-child(4n + 1), span:not(.skelet):nth-child(4n + 2)
            background-color: var(--color-grey-light)

        span:nth-child(4n + 2)
            border-radius: 0 0.75rem 0.75rem 0

    .actions
        display: flex
        gap: 1rem

        button, a
            width: 100%

    @include mappy-bp(max tablet)
        section
            grid-template-columns: repeat(2, 1fr)

        .actions
            flex-direction: column-reverse

    @include mappy-bp(max mobile)
        section:first-of-type
            grid-template-columns: 1fr 2fr
